import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';
const RESTORE_ERROR = 'restore_error';

let _users = [];
let _fetchedAll = false;
let _restoreError = {};

let _roles = [
 //   { name: 'Super admin', id: 'ROLE_SUPER_ADMIN' },
    { name: 'Admin',       id: 'ROLE_ADMIN' },
    { name: 'Manager',     id: 'ROLE_MANAGER' },
];

export const sanitise = ({id, dateAdded, lastLogin, ...rest}) => ({
    id: Number(id),
    ...rest,
    isAdmin: Number(rest.isAdmin),
    isManager: Number(rest.isManager),
    dateAdded: dateAdded && new Date(dateAdded),
    lastLogin: lastLogin && new Date(lastLogin),
    validFrom: rest.validFrom && new Date(rest.validFrom)
});

let UserStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    addRestoreErrorListener: function (callback)  {
        this.on(RESTORE_ERROR, callback);
        return { remove: () => this.removeRestoreErrorListener(callback) };
    },
    removeRestoreErrorListener: function (callback) {
        this.removeListener(RESTORE_ERROR, callback)
    },
    getAll: function() {
        return _users;
    },
    add: function(user) {
        user = sanitise(user);
        const userIndex = _users.findIndex( (u) => u !== undefined && u.id === user.id );
        if (userIndex < 0) {
            _users.push(user);
        } else {
            _users[userIndex] = user;
        }
    },
    update: function(entity) {
        _users[entity.id] = entity;
    },
    delete: (id) => {
        const index = _users.findIndex((e) => (e !== undefined && e.id == id));
        if (0 <= index) {
            delete _users[index];
        }
    },
    passwordReset: function(entity) {
        _users[entity.id] = entity;
    },
    getById: function(id) {
        return _users.find((u) => (u !== undefined && u.id == id) );
    },
    addManager: function(userId, manager) {
        let userIndex = _users.findIndex(function(u) { return u !== undefined && u.id == userId; } );
        if (userIndex >= 0) {

            let index = _users[userIndex].managers.findIndex(function(e) { return e !== undefined && e.id === manager.id; });

            if (index < 0) {
                _users[userIndex].managers.push(manager);
            } else {
                _users[userIndex].managers[index] = manager;
            }
        }
    },
    removeManager: function(userId, managerId) {
        let userIndex = _users.findIndex(function(u) { return u !== undefined && u.id == userId; } );
        if (userIndex >= 0) {

            let managerIndex = _users[userIndex].managers.findIndex(function(m) { return m !== undefined && m.id == managerId; });
            if (managerIndex >= 0) {
                delete _users[userIndex].managers[managerIndex];
            }
        }
    },
    addDepartment: function(userId, department) {
        userId = Number(userId);
        const uid = _users.findIndex((u) => !!u && u.id === userId );
        if (uid >= 0) {

            const did = _users[uid].departments.findIndex(d => !!d && d.id === department.id );

            if (did < 0) {
                _users[uid].departments = [
                    ..._users[uid].departments,
                    department
                ];
            } else {
                _users[uid].departments = _users[uid].departments.map((d, i) => (i === did ? department : d));
            }
        }
    },
    removeDepartment: function(userId, departmentId) {
        const uid = _users.findIndex((u) => !!u && u.id === userId );
        if (uid >= 0) {
            _users[uid].departments = _users[uid].departments.filter(d => !!d && d.id !== departmentId);
        }
    },
    addGroup: function(userId, group) {
        let userIndex = _users.findIndex(function(u) { return u !== undefined && u.id == userId; } );
        if (userIndex >= 0) {

            let index = _users[userIndex].userGroups.findIndex(function(e) { return e !== undefined && e.id === group.id; });

            if (index < 0) {
                _users[userIndex].userGroups.push(group);
            } else {
                _users[userIndex].userGroups[index] = group;
            }
        }
    },

    removeGroup: function(userId, groupId) {
        let userIndex = _users.findIndex(function(u) { return u !== undefined && u.id == userId; } );
        if (userIndex >= 0) {

            let groupIndex = _users[userIndex].userGroups.findIndex(function(m) { return m !== undefined && m.id == groupId; });
            if (groupIndex >= 0) {
                delete _users[userIndex].userGroups[groupIndex];
            }
        }
    },

    getRoleDescription: function(roleId) {
        let description = '';
        let roleIndex = _roles.findIndex(function(e) { return e !== undefined && e.id === roleId; } );
        if (roleIndex < 0) {
            console.error('Role description not found for ', roleId);
        } else {
            description = _roles[roleIndex].name;
        }
        return description;
    },

    getRoles: function() {
        return _roles;
    },

    removeEvent: function(userId, calendarId, eventId) {
        try {
            let user = UserStore.getById(userId);
            let calendars = user.calendars;
            let events = [];
            calendars.forEach(function(calendar) {
                events = calendar.events;
            });

            let index = events.findIndex(function(elem) { return elem !== undefined && elem.id === eventId; });

            if(index>= 0) {
                delete events[index];
            }

        } catch (e) {
            console.error(e);
        }

    },

    fetchedAll: () => (_fetchedAll),
    getRestoreError: () => (_restoreError)
});

UserStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.USER_LIST:
            if (action.data.length === 0) {
                _fetchedAll = true;
            } else {
                action.data.forEach( UserStore.add );
                _fetchedAll = false;
            }
            UserStore.emitChange();
            break;

        case ActionTypes.USER_LIST_ERROR:
            UserStore.emitChange();
            break;

        case ActionTypes.USER_INFO:
            UserStore.add(action.data);
            UserStore.emitChange();
            break;

        case ActionTypes.USER_INFO_ERROR:
            UserStore.emitChange();
            break;

        case ActionTypes.USER_SAVE:
            UserStore.add(action.data);
            UserStore.emitChange();
            break;

        case ActionTypes.USER_UPDATE:
            UserStore.add(action.data);
            UserStore.emitChange();
            break;

        case ActionTypes.USER_DELETE:
            if (!!action.data.deleted) {
                if (!action.payload.showDeleted) {
                    UserStore.delete(action.data.id);
                } else {
                    UserStore.add(action.data);
                }
                UserStore.emitChange();
            }
            break;

        case ActionTypes.USER_RESTORE_DELETED_REQUEST:
            _restoreError = {};
            break;

        case ActionTypes.USER_RESTORE_DELETED_SUCCESS:
            UserStore.add(action.data);
            UserStore.emitChange();
            break;

        case ActionTypes.USER_RESTORE_DELETED_FAILURE:
            _restoreError = {
                message: action.data,
                payload: action.payload
            }
            UserStore.emit(RESTORE_ERROR);
            break;

        case ActionTypes.USER_MANAGER_SAVE:
            if (action.data.assignedToId !== undefined) {
                UserStore.addManager(action.data.assignedToId, action.data);
                UserStore.emitChange();
            }
            break;

        case ActionTypes.USER_MANAGER_SAVE_ERROR:
            console.error('Manager Save Error - ' + action.message);
            UserStore.emitChange();
            break;

        case ActionTypes.USER_MANAGER_REMOVE:
            if (action.data.userId !== undefined && action.data.managerId !== undefined) {
                UserStore.removeManager(action.data.userId, action.data.managerId);
                UserStore.emitChange();
            }
            break;

        case ActionTypes.USER_DEPARTMENT_SAVE:
            if (action.data.assignedToId !== undefined) {
                UserStore.addDepartment(action.data.assignedToId, action.data);
                UserStore.emitChange();
            }
            break;

        case ActionTypes.USER_DEPARTMENT_REMOVE_SUCCESS:
            if (!!action.payload.id && !!action.payload.departmentId) {
                UserStore.removeDepartment(action.payload.id, action.payload.departmentId);
                UserStore.emitChange();
            }
            break;
        case ActionTypes.USER_DEPARTMENT_REMOVE_FAILURE:
            UserStore.emitChange();
            break;

        case ActionTypes.USER_GROUP_SAVE:
            if (action.data.assignedToId !== undefined) {
                UserStore.addGroup(action.data.assignedToId, action.data);
                UserStore.emitChange();
            }
            break;

        case ActionTypes.USER_GROUP_REMOVE_SUCCESS:
            if (!!action.payload.userId && !!action.payload.groupId) {
                UserStore.removeGroup(action.payload.userId, action.payload.groupId);
                UserStore.emitChange();
            }
            break;

        case ActionTypes.SETTING_SAVE_SUCCESS:
            if (action.payload.setting.name === 'SHOW_DELETED_USERS') {
                _users = [];
            }

        default:
            break;

    }

});

export default UserStore;
